<template>
  <div>
    <base-modal :title="title" :width="width" :visible="visible" @cancel="cancel()">
      <div slot="modalBody" class="public-modal">
        <a-form :form="form" @submit="handleSubmit" :selfUpdate="true">
          <a-row :gutter="8">
            <a-col :span="22">
              <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="题型" :hasFeedback="!isEdit">
                <a-select
                  placeholder="请选择题型类型"
                  :disabled="!isEdit"
                  showSearch
                  optionFilterProp="children"
                  :filterOption="filterOption"
                  @change="quesTypeChange"
                  v-decorator="[
                    'type',
                    { validateTrigger: ['change'], rules: [{ required: true, message: '请选择题型类型!' }] }
                  ]"
                >
                  <a-select-option v-for="type in subjectType" :key="type.id" :value="type.code">{{
                    type.name
                  }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :span="22">
              <span class="need-tip" style="left:68px;top:10px">*</span>
              <a-form-item label="题目" :labelCol="labelCol" :wrapperCol="wrapperCol" :hasFeedback="isEdit">
                <rich-text ref="titleText"></rich-text>
              </a-form-item>
            </a-col>
            <a-col :span="2">
              <a-icon type="area-chart" @click="changeTitleType" />
            </a-col>
            <a-col
              :span="21"
              :offset="3"
              v-if="quesType === 'TRAIN_SUBJECT_TYPE_4'"
              style="popsition:relative;top:-15px;left:15px;color:#aaa"
            >
              <p>填空题的空格请用占位符"###"代替,例如:举头望###</p>
            </a-col>

            <!-- 单选题 -->
            <a-col :span="22" v-if="quesType === 'TRAIN_SUBJECT_TYPE_1'">
              <p style="margin-left: 65px;"><span style="color:red">*</span> 选项：</p>
              <a-radio-group v-model="checkedValue" style="width:100%">
                <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  v-for="(k, index) in optionList"
                  :key="index"
                  :label="list[index]"
                >
                  <a-row>
                    <a-col :span="21">
                      <rich-text :ref="list[index]"></rich-text>
                      <span class="need-tip">*</span>
                    </a-col>
                    <a-col :span="3">
                      <a-radio style="margin: 8px" :value="list[index]"></a-radio>
                      <a-icon style="margin-right:8px" type="area-chart" @click="toggleFn(index)" />
                      <a-icon
                        v-if="optionList.length > 2"
                        class="dynamic-delete-button"
                        type="minus-circle-o"
                        @click="() => remove(k, index)"
                      />
                    </a-col>
                  </a-row>
                </a-form-item>
              </a-radio-group>
              <a-button type="dashed" style="margin-left:17%;margin-bottom:20px;width: 69%" @click="add">
                <a-icon
                  type="plus"
                /></a-button>
            </a-col>

            <!-- 多选题 -->
            <a-col :span="22" v-if="quesType === 'TRAIN_SUBJECT_TYPE_2'">
              <p style="margin-left: 65px"><span style="color:red">*</span> 选项：</p>
              <a-checkbox-group v-model="checkedList" style="width:100%">
                <a-form-item
                  :labelCol="labelCol"
                  :wrapperCol="wrapperCol"
                  v-for="(k, index) in optionList"
                  :key="index"
                  :label="list[index]"
                >
                  <a-row>
                    <a-col :span="21">
                      <rich-text :ref="list[index]"></rich-text>
                      <span class="need-tip">*</span>
                    </a-col>
                    <a-col :span="3">
                      <a-checkbox style="margin: 8px" :value="list[index]"></a-checkbox>
                      <a-icon style="margin-right:8px" type="area-chart" @click="toggleFn(index)" />
                      <a-icon
                        v-if="optionList.length > 2"
                        class="dynamic-delete-button"
                        type="minus-circle-o"
                        @click="() => remove(k, index)"
                      />
                    </a-col>
                  </a-row>
                </a-form-item>
              </a-checkbox-group>
              <a-button type="dashed" style="margin-left:17%;margin-bottom:20px;width: 69%" @click="add">
                <a-icon
                  type="plus"
                /></a-button>
            </a-col>

            <!-- 判断题 -->
            <a-col :span="22" v-if="quesType === 'TRAIN_SUBJECT_TYPE_3'">
              <a-form-item label="答案" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-radio-group
                  v-decorator="[
                    'correct',
                    {
                      validateTrigger: ['blur', 'change'],
                      rules: [
                        {
                          required: true,
                          message: '请选择答案'
                        }
                      ]
                    }
                  ]"
                >
                  <a-radio :value="1">正确</a-radio>
                  <a-radio :value="0">错误</a-radio>
                </a-radio-group>
              </a-form-item>
            </a-col>

            <!-- 填空题&简答题 -->
            <a-col :span="22" v-if="quesType === 'TRAIN_SUBJECT_TYPE_4' || quesType === 'TRAIN_SUBJECT_TYPE_5'">
              <a-form-item label="答案" :labelCol="labelCol" :wrapperCol="wrapperCol" :hasFeedback="isEdit">
                <a-textarea
                  :disabled="!isEdit"
                  :rows="4"
                  autocomplete="off"
                  placeholder="请输入答案"
                  v-decorator="[
                    'answer',
                    {
                      validateTrigger: ['blur'],
                      rules: [
                        {
                          required: true,
                          message: '答案不能为空'
                        },
                        {
                          max: 255,
                          message: '最多可输入255个字符'
                        }
                      ]
                    }
                  ]"
                />
              </a-form-item>
            </a-col>

            <a-col :span="22">
              <a-form-item label="题目分析" :labelCol="labelCol" :wrapperCol="wrapperCol" :hasFeedback="isEdit">
                <a-textarea
                  :disabled="!isEdit"
                  :rows="4"
                  autocomplete="off"
                  v-decorator="[
                    'remark',
                    {
                      validateTrigger: ['blur'],
                      rules: [
                        {
                          max: 255,
                          message: '最多可输入255个字符'
                        }
                      ]
                    }
                  ]"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-form-item :wrapper-col="{ span: 12, offset: 4 }" v-if="isEdit" style="margin-left: 15.3%;">
            <a-button type="primary" html-type="submit" :loading="btnLoading" style="margin-right:10px;">
              确定
            </a-button>
            <a-button style="margin-right:10px;" @click="cancel">
              取消
            </a-button>
          </a-form-item>
        </a-form>
      </div>
    </base-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { controlSubjectsDetail, getSubjectsDetail } from '@/api/subject'
import baseModal from '@/CrComponents/Modal/Modal.vue'

import richText from './richText'

export default {
  name: 'ItemBankModal',
  beforeCreate () {
    this.form = this.$form.createForm(this, { name: 'itemBank_form' })
  },
  components: {
    baseModal,
    richText
  },
  computed: {
    ...mapGetters(['subjectType', 'subjectBankId']),
    isEdit () {
      return this.type !== this.$sysInfo.MODAL_VIEW
    }
  },
  data () {
    return {
      optionList: [{ option: 'A' }, { option: 'B' }],
      optShowList: [true, true],
      titleType: true,
      quesType: '',
      checkedValue: '',
      checkedList: [],
      title: null,
      width: 800,
      visible: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      model: {},
      list: [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        '0',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z'
      ],
      type: 'MODAL_ADD', //  弹窗的类型： add:新增 |modify:修改 | del:删除
      btnLoading: false,
      subjectId: null,
      record: {}
    }
  },
  methods: {
    // 变更标题富文本的状态
    changeTitleType () {
      this.$refs.titleText.setStyle(!this.titleType)
      this.titleType = !this.titleType
    },
    // 变更答案富文本的状态
    toggleFn (index) {
      this.$refs[`${this.list[index]}`][0].setStyle(!this.optShowList[index])
      this.$set(this.optShowList, index, !this.optShowList[index])
    },
    // 题型变更
    quesTypeChange (key) {
      this.quesType = key
      this.optShowList = [true, true]
      this.optionList = [{ option: 'A' }, { option: 'B' }]
    },
    // 移除
    remove (k, index) {
      this.optShowList.splice(index, 1)
      this.reRender(k.option)
      // console.log("k",k)

      if (this.quesType === 'TRAIN_SUBJECT_TYPE_2') {
        const checkedList = []
        for (const c of this.checkedList) {
          // 选中的比被删除的大,则往前推1个字母
          if (c > k.option) {
            const position = this.list.indexOf(c)
            checkedList.push(this.list[position - 1])
          } else {
            checkedList.push(c)
          }
        }
        this.checkedList = checkedList
      }
    },
    // 新增
    add () {
      this.optShowList.push(true)
      this.optionList.push({
        option: this.list[this.optionList.length]
      })
    },
    // 重新渲染
    reRender (option) {
      var optionList = []
      console.log('this.optionList', this.optionList)

      for (const [index, item] of this.optionList.entries()) {
        const opt = {
          option: this.list[index],
          content: this.returnContentForDel(index, item),
          correct: this.returnCorrect(this.list[index], false)
        }

        if (this.optionList[index].id) opt.id = this.optionList[index].id

        optionList.push(opt)
      }

      for (var i = 0; i < optionList.length; i++) {
        if (optionList[i].option === option) {
          optionList.splice(i, 1)
        }
      }

      this.$nextTick(() => {
        for (const [index] of optionList.entries()) {
          optionList[index].option = this.list[index]
          if (optionList[index].content) {
            this.$refs[`${this.list[index]}`][0].setContent(optionList[index].content)
          } else {
            this.$refs[`${this.list[index]}`][0].setContent('')
          }
        }
        this.$set(this, 'optionList', optionList)
      })
    },
    // 设置类型
    setType (type) {
      this.type = type
    },
    // 设置标题
    setTitle (title) {
      this.title = title
    },
    // 设置model 参数 修改时传入
    setModel (model) {
      console.log('model', model)
      this.model = Object.assign({}, model)
    },
    // 打开or关闭，修改的窗口先获取详情
    open (flag) {
      this.formClear()
      this.visible = flag
      if (this.type === this.$sysInfo.MODAL_MODIFY || this.type === this.$sysInfo.MODAL_VIEW) {
        if (flag) {
          console.log('渲染数据')
          this.getModelInfo(this.model)
        }
      }
    },
    // 返回选项文本框里的文字
    returnContent (index, item) {
      if (
        this.$refs[`${this.list[index]}`][0].editorContent &&
        this.$refs[`${this.list[index]}`][0].editorContent !== '<p><br></p>'
      ) {
        return this.$refs[`${this.list[index]}`][0].editorContent.replace(/&nbsp;/gi, '')
      } else {
        this.$message.error(`选项${this.list[index]}为空,请输入答案`)
      }
    },
    // 返回选项文本框里的文字删除后
    returnContentForDel (index, item) {
      if (
        this.$refs[`${this.list[index]}`][0].editorContent &&
        this.$refs[`${this.list[index]}`][0].editorContent !== '<p><br></p>'
      ) {
        return this.$refs[`${this.list[index]}`][0].editorContent.replace(/&nbsp;/gi, '')
      }
    },
    // 返回正确答案
    returnCorrect (value) {
      // 单选的判断
      if (this.quesType === 'TRAIN_SUBJECT_TYPE_1') {
        return value === this.checkedValue ? 1 : 0
      } else {
        // 多选的判断
        return this.checkedList.indexOf(value) !== -1 ? 1 : 0
      }
    },
    // 返回判断题答案
    returnChecked (arr) {
      if (this.model.type === 'TRAIN_SUBJECT_TYPE_1') {
        return arr.filter(item => item.correct === 1)[0].option
      } else {
        return arr.filter(item => item.correct === 1).map(item => item.option)
      }
    },
    // 返回
    returnShowType (arr) {
      let showList = []
      showList = arr.map(item => (item.content.indexOf('<') === -1))
      return showList
    },
    // 提交表单
    handleSubmit (e) {
      console.log('点击提交')
      e.preventDefault()

      if (this.quesType === 'TRAIN_SUBJECT_TYPE_1') {
        if (!this.checkedValue) {
          this.$message.error('请先选择一个正确答案')
          return
        }
      }

      if (this.quesType === 'TRAIN_SUBJECT_TYPE_2') {
        if (this.checkedList.length < 2) {
          this.$message.error('请至少选择两个正确答案')
          return
        }
      }

      this.form.validateFieldsAndScroll((err, value) => {
        if (!err) {
          const params = { ...value }

          if (this.quesType === 'TRAIN_SUBJECT_TYPE_4' && this.$refs.titleText.editorContent.match('###') === null) {
            this.$message.error('填空题的题目必需要有占位符"###"')
            return
          }

          if (this.$refs.titleText.editorContent && this.$refs.titleText.editorContent !== '<p><br></p>') {
            params.title = this.$refs.titleText.editorContent.replace(/&nbsp;/gi, '')
          } else {
            this.$message.error('题目不能为空')
            return
          }

          // 单选题&多选题的参数
          if (this.quesType === 'TRAIN_SUBJECT_TYPE_1' || this.quesType === 'TRAIN_SUBJECT_TYPE_2') {
            var optionList = []
            for (const [index, item] of this.optShowList.entries()) {
              const opt = {
                option: this.list[index],
                content: this.returnContent(index, item),
                correct: this.returnCorrect(this.list[index])
              }

              if (opt.content === undefined) {
                return
              }

              if (this.subjectId) opt.subjectId = this.subjectId
              if (this.optionList[index].id) opt.id = this.optionList[index].id

              optionList.push(opt)
            }
            // console.log('optionList', optionList)
            params.optionList = optionList
          }

          // 填空题&简答题的参数
          if (this.quesType === 'TRAIN_SUBJECT_TYPE_4' || this.quesType === 'TRAIN_SUBJECT_TYPE_5') {
            const fill = {
              answer: params.answer
            }

            if (this.subjectId) fill.subjectId = this.subjectId
            if (this.record && this.record.fill && this.record.fill.id) fill.id = this.record.fill.id

            params.fill = fill
          }

          params.subjectBankId = this.subjectBankId
          if (this.model.id) params.id = this.model.id

          console.log('params', params)

          // return

          controlSubjectsDetail(params).then(res => {
            if (res.status === 0) {
              this.$message.success('操作成功')
              this.$emit('refreshTable')
              this.cancel()
            } else {
              this.$message.error(res.info.message)
            }
          })
        }
      })
    },
    // 获取当前的model详情
    getModelInfo () {
      console.log('模型数据', this.model)
      this.quesType = this.model.type
      this.subjectId = this.model.id
      this.titleType = this.model.title.indexOf('<') === -1

      getSubjectsDetail(this.model.id).then(res => {
        console.log('题目', res)

        const record = res.data
        this.record = record

        this.form.setFieldsValue({
          type: record.type,
          remark: record.remark
        })

        // 设置标题
        this.$refs.titleText.setContent(record.title)

        switch (record.type) {
          case 'TRAIN_SUBJECT_TYPE_1': // 单选
            this.optShowList = this.returnShowType(record.optionList)
            this.checkedValue = this.returnChecked(record.optionList)
            this.optionList = record.optionList

            this.$nextTick(() => {
              for (const [index] of this.optShowList.entries()) {
                this.$refs[`${this.list[index]}`][0].setContent(record.optionList[index].content)
              }
            })

            break
          case 'TRAIN_SUBJECT_TYPE_2': // 多选
            this.optShowList = this.returnShowType(record.optionList)
            this.checkedList = this.returnChecked(record.optionList)
            this.optionList = record.optionList

            this.$nextTick(() => {
              for (const [index] of this.optShowList.entries()) {
                this.$refs[`${this.list[index]}`][0].setContent(record.optionList[index].content)
              }
            })
            break
          case 'TRAIN_SUBJECT_TYPE_3': // 判断
            this.form.setFieldsValue({
              correct: record.correct
            })
            break
          case 'TRAIN_SUBJECT_TYPE_4': // 填空
            this.$nextTick(() => {
              this.form.setFieldsValue({
                answer: record.fill.answer
              })
            })

            break
          case 'TRAIN_SUBJECT_TYPE_5': // 简答
            this.$nextTick(() => {
              this.form.setFieldsValue({
                answer: record.fill.answer
              })
            })

            break
          default:
            break
        }
      })
    },
    // 清空表单
    formClear () {
      this.form.resetFields()
      this.quesType = null
    },
    cancel () {
      console.log('关闭')
      this.formClear()
      this.open(false)
      this.model = {}
      this.checkedList = []
      this.$refs.titleText.setContent('')
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }
  }
}
</script>

<style lang="less">
.public-date {
  .ant-calendar-picker {
    width: 100%;
  }
}

.ant-collapse .ant-collapse-item .ant-collapse-header .anticon {
  left: initial;
  right: 16px;
}

.need-tip {
  position: absolute;
  top: 0px;
  font-size: 16px;
  left: -30px;
  color: #f5222d;
}
</style>
